import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import {
    asyncGetLabelParams,
    asyncGetParams,
} from '../../../../../services/param.service';
import { CasesGeneralFilter } from '../../../../../shared/types/modules/cases-general';

export const useCasesGeneralFilters = (
    onFilter?: (data: CasesGeneralFilter) => void
) => {
    const [typification1, setTypification1] = useState<ISelect[]>([]);
    const [typification2, setTypification2] = useState<ISelect[]>([]);
    const callId = '';
    const policie = '';
    const [status, setStatus] = useState<ISelect[]>([]);
    const [branch, setBranch] = useState<ISelect[]>([]);

    const onSubmit = (data: CasesGeneralFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues: {
            ...initialValues,
            callId: callId?.trim() || '',
        },
        onSubmit,
    });

    useEffect(() => {
        if (formik.values.callId?.trim()) {
            formik.submitForm();
        }
    }, [callId, formik.values.callId]);

    useEffect(() => {
        asyncGetLabelParams(
            ParamEnum.CASES_GENERAL_INFORMATION_TYPIFICATION1
        ).then((params) =>
            setTypification1(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(
            ParamEnum.CASES_GENERAL_INFORMATION_TYPIFICATION2
        ).then((params) =>
            setTypification2(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetParams(ParamEnum.PQR_REDIRECTION_AREA).then((params) =>
            setBranch(params)
        );
        asyncGetParams(ParamEnum.PQR_STATUS).then((status) =>
            setStatus(status)
        );
    }, []);

    return {
        formik,
        typification1,
        typification2,
        branch,
        status,
        policie,
    };
};
